import { CrossIcon, SuccessIcon } from '../../../shared/ui/icons'
import { Box, Typography } from '@material-ui/core'
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

interface FinishProps {
  errorMessage: string | undefined;

  totalItems: number

  handleRerunPulling: () => Promise<void>
}

export const Finish = ({errorMessage, totalItems, handleRerunPulling}: FinishProps) => {
  const classes = useStyles()

  return (
    <Box className={classes.finishWrapper}>
      {errorMessage ? (
        <div className={classes.errorAnimation}>
          <CrossIcon/>
        </div>
      ) : (
         <div className={classes.successAnimation}>
           <SuccessIcon/>
         </div>
       )}

      <Typography
        color="textSecondary"
        style={{
          marginTop: 12,
          fontSize: 16,
          textAlign: 'center'
        }}
      >
        {errorMessage ? (
          <>
            <span className={classes.error}>Произошла ошибка:</span> {errorMessage}<br/>
            Пожалуйста, обратитесь в службу поддержки или{' '}
            <span className={classes.inlineButton} onClick={handleRerunPulling}>попробуйте снова</span>.
          </>
        ) : (
          <>
            Обновление {totalItems} товаров завершено успешно!<br/>
            <span className={classes.inlineButton} onClick={handleRerunPulling}>Еще раз</span>
          </>
         )}
      </Typography>
    </Box>
  )
}

const useStyles = makeStyles(
  () => ({
    finishWrapper: {
      display: 'flex',
      height: '100%',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 40
    },
    error: {
      fontWeight: 500
    },
    inlineButton: {
      textDecoration: 'underline',
      cursor: 'pointer'
    },
    successAnimation: {
      animation: '$bounceIn 600ms ease-out',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    '@keyframes bounceIn': {
      '0%': {
        transform: 'scale(0.8)',
        opacity: 0
      },
      '60%': {
        transform: 'scale(1.1)',
        opacity: 1
      },
      '80%': {
        transform: 'scale(0.95)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    },
    errorAnimation: {
      animation: '$headShake 600ms',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    '@keyframes headShake': {
      '0%': {transform: 'translateX(0)'},
      '10%': {transform: 'translateX(-5px) rotate(-5deg)'},
      '20%': {transform: 'translateX(5px) rotate(5deg)'},
      '30%': {transform: 'translateX(-5px) rotate(-5deg)'},
      '40%': {transform: 'translateX(5px) rotate(5deg)'},
      '50%': {transform: 'translateX(-5px) rotate(-5deg)'},
      '60%': {transform: 'translateX(5px) rotate(5deg)'},
      '70%': {transform: 'translateX(-5px) rotate(-5deg)'},
      '80%': {transform: 'translateX(5px) rotate(5deg)'},
      '90%': {transform: 'translateX(-5px) rotate(-5deg)'},
      '100%': {transform: 'translateX(0)'}
    }
  }))